import { render, staticRenderFns } from "./MailTemplateOverview.vue?vue&type=template&id=47901901"
import script from "./MailTemplateOverview.vue?vue&type=script&lang=js"
export * from "./MailTemplateOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports